import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function App() {
  const [status, setStatus] = useState('');
  const [integrations, setIntegrations] = useState([]);

  const connectService = async (service, payload) => {
    try {
      const res = await axios.post(`${API_BASE}/api/integrations/${service}`, payload);
      setStatus(res.data.status);
      fetchIntegrations();
    } catch (err) {
      setStatus('Connection failed.');
    }
  };

  const fetchIntegrations = async () => {
    const res = await axios.get(`${API_BASE}/api/integrations`);
    setIntegrations(res.data);
  };

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <div className="min-h-screen bg-green-900 text-white flex flex-col items-center justify-center space-y-6 p-6">
      <h1 className="text-4xl font-bold">Puzzlebox.cloud Integrations</h1>
      <button className="bg-white text-green-900 px-4 py-2 rounded shadow" onClick={() => connectService('brilliant', { token: 'brilliant_token' })}>Connect to Brilliant</button>
      <button className="bg-white text-green-900 px-4 py-2 rounded shadow" onClick={() => connectService('solaredge', { token: 'solaredge_api_key' })}>Connect to SolarEdge</button>
      <button className="bg-white text-green-900 px-4 py-2 rounded shadow" onClick={() => connectService('alexa', { token: 'alexa_auth_code' })}>Connect to Amazon Alexa</button>
      <button className="bg-white text-green-900 px-4 py-2 rounded shadow" onClick={() => connectService('nest', { token: 'google_nest_token' })}>Connect to Google Nest</button>

      <div className="mt-4 text-lg">Status: {status}</div>

      <div className="mt-6">
        <h2 className="text-2xl mb-2">Connected Services:</h2>
        <ul>
          {integrations.map((intg, i) => (
            <li key={i}>{intg.service} - Connected on {new Date(intg.createdAt).toLocaleDateString()}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default App;
